import React from 'react';
import { AiFillPlusSquare } from 'react-icons/ai';

import * as S from './styles';
import { color } from 'styles/pallete';

interface AddBtnProps {
	text: string;
	anyFunction: any;
	colorBackgroudPlus?: string;
	untouchable?: boolean;
}

export default function AddBtn({
	text,
	anyFunction,
	colorBackgroudPlus = '',
	untouchable = false
}: AddBtnProps) {
	return (
		<S.container $untouchable={untouchable}>
			<S.addNewCard
				data-testid="add-btn"
				onClick={() => {
					if (!untouchable) {
						anyFunction();
					}
				}}
			>
				<AiFillPlusSquare
					style={{
						color:
							colorBackgroudPlus !== ''
								? colorBackgroudPlus
								: color.interface.green2,
						fontSize: '20px',
						cursor: 'pointer',
						transition: 'all ease .5s'
					}}
				/>
				<p>{text}</p>
			</S.addNewCard>
		</S.container>
	);
}
